import React from 'react';

const temp = () => {
    return <div></div>;
};

export default temp;
